<template>
  <div>
    <div class="filter-card">
      <el-form :model="query" inline label-width="78px" size="small">
        <el-form-item label="关键词"><el-input v-model="query.keyword" clearable placeholder="品牌/货号/备注" /></el-form-item>
        <el-form-item label="品牌"><el-input v-model="query.brandName" clearable placeholder="手动输入的品牌" /></el-form-item>
        <el-form-item label="货号"><el-input v-model="query.itemNo" clearable placeholder="货号" /></el-form-item>
        <el-form-item label="品类">
          <el-select v-model="query.category" clearable placeholder="全部" style="width:120px">
            <el-option v-for="c in categories" :key="c" :label="c" :value="c" />
          </el-select>
        </el-form-item>
        <el-form-item label="尺码"><el-input v-model="query.size" clearable placeholder="尺码" style="width:120px" /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.saleStatus" clearable placeholder="全部" style="width:120px">
            <el-option label="库存中" :value="0" />
            <el-option label="已卖出" :value="1" />
            <el-option label="已退货/取消" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="滞销天数">
          <el-input-number v-model="query.minStagnantDays" :min="0" :precision="0" :controls="false" placeholder="≥ 天数" style="width:120px" />
        </el-form-item>
        <el-form-item label="购买时间">
          <el-date-picker class="desktop-date-picker" v-model="query.purchaseRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始" end-placeholder="结束" />
          <div class="mobile-date-range">
            <label class="mobile-date-field">
              <span>开始</span>
              <input v-model="query.purchaseDateStart" class="mobile-date-input" type="date" aria-label="购买开始日期">
            </label>
            <label class="mobile-date-field">
              <span>结束</span>
              <input v-model="query.purchaseDateEnd" class="mobile-date-input" type="date" aria-label="购买结束日期">
            </label>
          </div>
        </el-form-item>
        <el-form-item label="卖出时间">
          <el-date-picker class="desktop-date-picker" v-model="query.saleRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始" end-placeholder="结束" />
          <div class="mobile-date-range">
            <label class="mobile-date-field">
              <span>开始</span>
              <input v-model="query.saleDateStart" class="mobile-date-input" type="date" aria-label="卖出开始日期">
            </label>
            <label class="mobile-date-field">
              <span>结束</span>
              <input v-model="query.saleDateEnd" class="mobile-date-input" type="date" aria-label="卖出结束日期">
            </label>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="page-card">
      <div class="toolbar">
        <h3 class="toolbar-title">商品记录</h3>
        <div>
          <el-button size="small" icon="el-icon-download" @click="downloadExport">导出CSV</el-button>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="openCreate">新增商品</el-button>
        </div>
      </div>

      <el-table v-loading="loading" :data="list" border stripe class="desktop-item-table" @sort-change="handleSortChange">
        <el-table-column prop="brandName" label="品牌" min-width="120" fixed="left" />
        <el-table-column prop="itemNo" label="货号" min-width="130" />
        <el-table-column prop="category" label="品类" width="90" />
        <el-table-column prop="size" label="尺码" width="100" />
        <el-table-column prop="purchasePrice" label="买入价" width="120" align="right" sortable="custom">
          <template slot-scope="scope"><span class="money-font">¥{{ money(scope.row.purchasePrice) }}</span></template>
        </el-table-column>
        <el-table-column prop="purchaseDate" label="购买时间" width="120" sortable="custom" />
        <el-table-column prop="stagnantDays" label="滞销时间" width="110" align="right" sortable="custom">
          <template slot-scope="scope"><span v-if="scope.row.saleStatus !== 1">{{ stagnantDays(scope.row.purchaseDate) }}天</span><span v-else class="text-muted">-</span></template>
        </el-table-column>
        <el-table-column prop="saleStatus" label="状态" width="100">
          <template slot-scope="scope"><el-tag size="mini" :type="statusTag(scope.row.saleStatus)">{{ statusText(scope.row.saleStatus) }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="salePrice" label="卖出价" width="120" align="right" sortable="custom">
          <template slot-scope="scope"><span v-if="scope.row.salePrice !== null" class="money-font">¥{{ money(scope.row.salePrice) }}</span><span v-else class="text-muted">-</span></template>
        </el-table-column>
        <el-table-column prop="saleDate" label="卖出时间" width="120" sortable="custom">
          <template slot-scope="scope">{{ scope.row.saleDate || '-' }}</template>
        </el-table-column>
        <el-table-column prop="profit" label="利润" width="120" align="right" sortable="custom">
          <template slot-scope="scope"><span v-if="scope.row.profit !== null" class="money-font" :class="Number(scope.row.profit) >= 0 ? 'profit-positive' : 'profit-negative'">¥{{ money(scope.row.profit) }}</span><span v-else class="text-muted">-</span></template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.saleStatus !== 1" type="text" @click="openSell(scope.row)">登记卖出</el-button>
            <el-button v-else type="text" @click="cancelSell(scope.row)">取消卖出</el-button>
            <el-button type="text" class="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-loading="loading" class="mobile-product-list">
        <el-empty v-if="!loading && !list.length" description="暂无商品记录" :image-size="90" />
        <div v-for="row in list" :key="row.id" class="mobile-product-card">
          <div class="mobile-card-head">
            <div class="mobile-card-title-wrap">
              <div class="mobile-card-brand">{{ row.brandName }}</div>
              <div class="mobile-card-sub">货号 {{ row.itemNo }} · {{ row.category }} · {{ row.size || '无尺码' }}</div>
            </div>
            <el-tag size="mini" :type="statusTag(row.saleStatus)">{{ statusText(row.saleStatus) }}</el-tag>
          </div>

          <div class="mobile-money-grid">
            <div class="mobile-money-item mobile-cost-item">
              <span>买入价</span>
              <strong class="money-font">¥{{ money(row.purchasePrice) }}</strong>
            </div>
            <div class="mobile-money-item mobile-sale-item">
              <span>卖出价</span>
              <strong v-if="row.salePrice !== null" class="money-font">¥{{ money(row.salePrice) }}</strong>
              <strong v-else class="text-muted">-</strong>
            </div>
            <div class="mobile-money-item mobile-profit-item" :class="row.profit !== null && Number(row.profit) < 0 ? 'is-loss' : (row.profit !== null ? 'is-gain' : '')">
              <span>利润</span>
              <strong v-if="row.profit !== null" class="money-font" :class="Number(row.profit) >= 0 ? 'profit-positive' : 'profit-negative'">¥{{ money(row.profit) }}</strong>
              <strong v-else class="text-muted">-</strong>
            </div>
          </div>

          <div class="mobile-date-row">
            <span><i class="el-icon-date"></i> 买入 {{ row.purchaseDate || '-' }}</span>
            <span v-if="row.saleStatus !== 1"><i class="el-icon-time"></i> 滞销 {{ stagnantDays(row.purchaseDate) }}天</span>
            <span v-if="row.saleDate"><i class="el-icon-sold-out"></i> 卖出 {{ row.saleDate }}</span>
          </div>

          <div v-if="row.remark" class="mobile-remark">备注：{{ row.remark }}</div>

          <div class="mobile-card-actions">
            <el-button size="mini" @click="openEdit(row)">编辑</el-button>
            <el-button v-if="row.saleStatus !== 1" size="mini" type="primary" plain @click="openSell(row)">登记卖出</el-button>
            <el-button v-else size="mini" type="warning" plain @click="cancelSell(row)">取消卖出</el-button>
            <el-button size="mini" type="danger" plain @click="remove(row)">删除</el-button>
          </div>
        </div>
      </div>

      <div class="pager desktop-pager">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="query.pageNum" :page-size.sync="query.pageSize" :page-sizes="[10,20,50,100]" :total="total" @size-change="load" @current-change="load" />
      </div>
      <div class="pager mobile-pager">
        <el-pagination background layout="prev, pager, next" :current-page.sync="query.pageNum" :page-size="query.pageSize" :total="total" @current-change="load" />
      </div>
    </div>

    <el-dialog :title="itemDialogTitle" :visible.sync="itemDialogVisible" width="620px" :close-on-click-modal="false" custom-class="ledger-dialog item-dialog">
      <el-form ref="itemForm" :model="itemForm" :rules="itemRules" label-width="100px">
        <el-row :gutter="12">
          <el-col :xs="24" :sm="12"><el-form-item label="品牌" prop="brandName"><el-input v-model="itemForm.brandName" placeholder="例如 Gucci / Nike" /></el-form-item></el-col>
          <el-col :xs="24" :sm="12"><el-form-item label="货号" prop="itemNo"><el-input v-model="itemForm.itemNo" placeholder="例如 407878-01" /></el-form-item></el-col>
          <el-col :xs="24" :sm="12"><el-form-item label="品类" prop="category"><el-select v-model="itemForm.category" placeholder="请选择" style="width:100%"><el-option v-for="c in categories" :key="c" :label="c" :value="c" /></el-select></el-form-item></el-col>
          <el-col :xs="24" :sm="12"><el-form-item label="尺码"><el-input v-model="itemForm.size" placeholder="鞋码/衣服码" /></el-form-item></el-col>
          <el-col :xs="24" :sm="12"><el-form-item label="买入价格" prop="purchasePrice"><el-input-number v-model="itemForm.purchasePrice" :min="0" :precision="2" :controls="false" style="width:100%" /></el-form-item></el-col>
          <el-col :xs="24" :sm="12"><el-form-item label="购买时间" prop="purchaseDate"><el-date-picker class="desktop-date-picker" v-model="itemForm.purchaseDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%" /><input v-model="itemForm.purchaseDate" class="mobile-native-date mobile-date-input" type="date" aria-label="购买时间"></el-form-item></el-col>
          <el-col :xs="24"><el-form-item label="备注"><el-input v-model="itemForm.remark" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="itemDialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitItem">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="登记卖出" :visible.sync="sellDialogVisible" width="560px" :close-on-click-modal="false" custom-class="ledger-dialog sell-dialog">
      <el-alert v-if="sellTarget" :title="`${sellTarget.brandName} / ${sellTarget.itemNo} / ${sellTarget.size || '无尺码'}`" type="info" :closable="false" class="sell-alert" />
      <el-form ref="sellForm" :model="sellForm" :rules="sellRules" label-width="110px">
        <el-form-item label="卖出价格" prop="salePrice"><el-input-number v-model="sellForm.salePrice" :min="0" :precision="2" :controls="false" style="width:100%" /></el-form-item>
        <el-form-item label="卖出时间" prop="saleDate"><el-date-picker class="desktop-date-picker" v-model="sellForm.saleDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%" /><input v-model="sellForm.saleDate" class="mobile-native-date mobile-date-input" type="date" aria-label="卖出时间"></el-form-item>
        <el-form-item label="卖出备注"><el-input v-model="sellForm.saleRemark" type="textarea" :rows="3" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="sellDialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitSell">确认卖出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { pageItems, createItem, updateItem, deleteItem, sellItem, unsellItem, exportItems } from '@/api/items'
import { money, statusText, statusTag, stagnantDays } from '@/utils/format'

const emptyItem = () => ({ brandName: '', itemNo: '', category: '鞋', size: '', purchasePrice: 0, purchaseDate: dayjs().format('YYYY-MM-DD'), remark: '' })
const emptySell = () => ({ salePrice: 0, saleDate: dayjs().format('YYYY-MM-DD'), saleRemark: '' })
const emptyQuery = () => ({ pageNum: 1, pageSize: 10, keyword: '', brandName: '', itemNo: '', category: '', size: '', saleStatus: null, minStagnantDays: null, purchaseRange: [], saleRange: [], purchaseDateStart: '', purchaseDateEnd: '', saleDateStart: '', saleDateEnd: '', sortBy: '', sortOrder: '' })

export default {
  name: 'ItemList',
  data() {
    return {
      categories: ['鞋', '服装', '包', '配饰', '其他'],
      loading: false,
      submitting: false,
      total: 0,
      list: [],
      query: emptyQuery(),
      itemDialogVisible: false,
      itemDialogTitle: '新增商品',
      editingId: null,
      itemForm: emptyItem(),
      itemRules: {
        brandName: [{ required: true, message: '请输入品牌', trigger: 'blur' }],
        itemNo: [{ required: true, message: '请输入货号', trigger: 'blur' }],
        category: [{ required: true, message: '请选择品类', trigger: 'change' }],
        purchasePrice: [{ required: true, message: '请输入买入价格', trigger: 'blur' }],
        purchaseDate: [{ required: true, message: '请选择购买时间', trigger: 'change' }]
      },
      sellDialogVisible: false,
      sellTarget: null,
      sellForm: emptySell(),
      sellRules: {
        salePrice: [{ required: true, message: '请输入卖出价格', trigger: 'blur' }],
        saleDate: [{ required: true, message: '请选择卖出时间', trigger: 'change' }]
      }
    }
  },
  mounted() { this.load() },
  methods: {
    money, statusText, statusTag, stagnantDays,
    handleSortChange({ prop, order }) {
      this.query.sortBy = order ? prop : ''
      this.query.sortOrder = order ? (order === 'ascending' ? 'asc' : 'desc') : ''
      this.query.pageNum = 1
      this.load()
    },
    buildParams() {
      const p = { ...this.query }
      if (p.purchaseRange && p.purchaseRange.length === 2) { p.purchaseDateStart = p.purchaseRange[0]; p.purchaseDateEnd = p.purchaseRange[1] }
      if (p.saleRange && p.saleRange.length === 2) { p.saleDateStart = p.saleRange[0]; p.saleDateEnd = p.saleRange[1] }
      delete p.purchaseRange; delete p.saleRange
      Object.keys(p).forEach(k => { if (p[k] === '' || p[k] === null || typeof p[k] === 'undefined') delete p[k] })
      return p
    },
    async load() {
      this.loading = true
      try {
        const data = await pageItems(this.buildParams())
        this.list = data.list || []
        this.total = data.total || 0
      } finally { this.loading = false }
    },
    search() { this.query.pageNum = 1; this.load() },
    reset() { this.query = emptyQuery(); this.load() },
    openCreate() { this.editingId = null; this.itemDialogTitle = '新增商品'; this.itemForm = emptyItem(); this.itemDialogVisible = true; this.$nextTick(() => this.$refs.itemForm && this.$refs.itemForm.clearValidate()) },
    openEdit(row) { this.editingId = row.id; this.itemDialogTitle = '编辑商品'; this.itemForm = { brandName: row.brandName, itemNo: row.itemNo, category: row.category, size: row.size, purchasePrice: row.purchasePrice, purchaseDate: row.purchaseDate, remark: row.remark }; this.itemDialogVisible = true; this.$nextTick(() => this.$refs.itemForm && this.$refs.itemForm.clearValidate()) },
    submitItem() {
      this.$refs.itemForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.editingId) await updateItem(this.editingId, this.itemForm)
          else await createItem(this.itemForm)
          this.$message.success('保存成功')
          this.itemDialogVisible = false
          this.load()
        } finally { this.submitting = false }
      })
    },
    openSell(row) { this.sellTarget = row; this.sellForm = emptySell(); this.sellDialogVisible = true; this.$nextTick(() => this.$refs.sellForm && this.$refs.sellForm.clearValidate()) },
    submitSell() {
      this.$refs.sellForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await sellItem(this.sellTarget.id, this.sellForm)
          this.$message.success('卖出登记成功')
          this.sellDialogVisible = false
          this.load()
        } finally { this.submitting = false }
      })
    },
    cancelSell(row) {
      this.$confirm('确定取消这条记录的卖出信息，并恢复为库存中吗？', '确认操作', { type: 'warning' }).then(async () => {
        await unsellItem(row.id)
        this.$message.success('已取消卖出')
        this.load()
      })
    },
    remove(row) {
      this.$confirm(`确定删除 ${row.brandName} / ${row.itemNo} 这条记录吗？`, '删除确认', { type: 'warning' }).then(async () => {
        await deleteItem(row.id)
        this.$message.success('删除成功')
        this.load()
      })
    },
    async downloadExport() {
      const res = await exportItems(this.buildParams())
      const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `商品对账明细-${dayjs().format('YYYY-MM-DD')}.csv`
      a.click()
      window.URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>
.pager { display: flex; justify-content: flex-end; margin-top: 16px; }
.danger { color: #dc2626; }
.sell-alert { margin-bottom: 16px; }
.mobile-product-list { display: none; }
.mobile-pager { display: none; }

@media (max-width: 768px) {
  .desktop-item-table,
  .desktop-pager {
    display: none;
  }

  .mobile-product-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .mobile-product-card {
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    padding: 14px;
    box-shadow: 0 8px 22px rgba(15, 23, 42, .06);
  }

  .mobile-card-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 12px;
  }

  .mobile-card-title-wrap {
    min-width: 0;
    flex: 1;
  }

  .mobile-card-brand {
    color: #111827;
    font-size: 17px;
    font-weight: 800;
    line-height: 1.25;
    word-break: break-word;
  }

  .mobile-card-sub {
    margin-top: 4px;
    color: #6b7280;
    font-size: 12px;
    line-height: 1.4;
    word-break: break-word;
  }

  .mobile-money-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 10px;
  }

  .mobile-money-item {
    min-height: 62px;
    border-radius: 13px;
    background: #f8fafc;
    border: 1px solid #edf2f7;
    padding: 8px;
  }

  .mobile-money-item span {
    display: block;
    color: #64748b;
    font-size: 11px;
    line-height: 1;
    margin-bottom: 8px;
  }

  .mobile-money-item strong {
    display: block;
    color: #0f172a;
    font-size: 15px;
    line-height: 1.2;
    word-break: break-all;
  }

  .mobile-cost-item {
    background: #f8fafc;
    border-color: #e2e8f0;
  }

  .mobile-sale-item {
    background: #eff6ff;
    border-color: #bfdbfe;
  }

  .mobile-sale-item span {
    color: #1d4ed8;
  }

  .mobile-sale-item strong:not(.text-muted) {
    color: #2563eb;
  }

  .mobile-profit-item {
    background: #f8fafc;
    border-color: #e2e8f0;
  }

  .mobile-profit-item.is-gain {
    background: #ecfdf5;
    border-color: #bbf7d0;
  }

  .mobile-profit-item.is-gain span {
    color: #047857;
  }

  .mobile-profit-item.is-loss {
    background: #fef2f2;
    border-color: #fecaca;
  }

  .mobile-profit-item.is-loss span {
    color: #b91c1c;
  }

  .mobile-profit-item strong.profit-positive {
    color: #059669;
  }

  .mobile-profit-item strong.profit-negative {
    color: #dc2626;
  }

  .mobile-date-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 12px;
    color: #64748b;
    font-size: 12px;
    margin: 2px 0 10px;
  }

  .mobile-date-row i {
    margin-right: 2px;
  }

  .mobile-remark {
    margin: 8px 0 10px;
    padding: 9px 10px;
    border-radius: 12px;
    background: #fff7ed;
    color: #9a3412;
    font-size: 12px;
    line-height: 1.5;
    word-break: break-word;
  }

  .mobile-card-actions {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    padding-top: 10px;
    border-top: 1px solid #eef2f7;
  }

  .mobile-card-actions .el-button {
    min-height: 38px;
    margin-left: 0;
    padding-left: 6px;
    padding-right: 6px;
    font-weight: 700;
  }

  .mobile-pager {
    display: flex;
    justify-content: center;
  }

  /deep/ .ledger-dialog {
    width: 92vw !important;
    margin-top: 7vh !important;
    border-radius: 16px;
  }

  /deep/ .ledger-dialog .el-dialog__body {
    padding: 18px 16px 8px;
  }

  /deep/ .ledger-dialog .el-dialog__footer {
    padding: 12px 16px 18px;
  }

  /deep/ .item-dialog .el-form-item {
    margin-bottom: 14px;
  }

  /deep/ .item-dialog .el-form-item__label,
  /deep/ .sell-dialog .el-form-item__label {
    width: 86px !important;
    font-size: 14px;
  }

  /deep/ .item-dialog .el-form-item__content,
  /deep/ .sell-dialog .el-form-item__content {
    margin-left: 86px !important;
  }
}
</style>
